"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var core_2 = require("@ngx-translate/core");
var flex_layout_1 = require("@angular/flex-layout");
var material_module_1 = require("../material.module");
var shared_module_1 = require("../shared/shared.module");
var login_routing_module_1 = require("./login-routing.module");
var login_component_1 = require("./login.component");
var LoginModule = /** @class */ (function () {
    function LoginModule() {
    }
    LoginModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.ReactiveFormsModule,
                core_2.TranslateModule,
                shared_module_1.SharedModule,
                flex_layout_1.FlexLayoutModule,
                material_module_1.MaterialModule,
                login_routing_module_1.LoginRoutingModule
            ],
            declarations: [
                login_component_1.LoginComponent
            ]
        })
    ], LoginModule);
    return LoginModule;
}());
exports.LoginModule = LoginModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9naW4ubW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibG9naW4ubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHNDQUF5QztBQUN6QywwQ0FBK0M7QUFDL0Msd0NBQXFEO0FBQ3JELDRDQUFzRDtBQUN0RCxvREFBd0Q7QUFFeEQsc0RBQW9EO0FBQ3BELHlEQUF1RDtBQUN2RCwrREFBNEQ7QUFDNUQscURBQW1EO0FBZ0JuRDtJQUFBO0lBQ0EsQ0FBQztJQURZLFdBQVc7UUFkdkIsZUFBUSxDQUFDO1lBQ04sT0FBTyxFQUFFO2dCQUNMLHFCQUFZO2dCQUNaLDJCQUFtQjtnQkFDbkIsc0JBQWU7Z0JBQ2YsNEJBQVk7Z0JBQ1osOEJBQWdCO2dCQUNoQixnQ0FBYztnQkFDZCx5Q0FBa0I7YUFDckI7WUFDRCxZQUFZLEVBQUU7Z0JBQ1YsZ0NBQWM7YUFDakI7U0FDSixDQUFDO09BQ1csV0FBVyxDQUN2QjtJQUFELGtCQUFDO0NBQUEsQUFERCxJQUNDO0FBRFksa0NBQVcifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.module.ts
// module id = 625
// module chunks = 0